export function RequestLocation() {
  console.log('To be implemented with Adobe')
}
